<template>
  <q-dialog :value="value" @hide="$emit('input', false)" persistent>
    <q-card flat style="min-width: 360px; max-width: 640px">
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title>{{ $t('weekly_brief_title') }}</q-toolbar-title>
        <q-btn flat round dense icon="mdi-close" @click="$emit('input', false)" />
      </q-toolbar>
      <q-card-section v-if="row">
        <div class="text-subtitle2 q-mb-xs">{{ row.type_description || $t('weekly_brief_title') }}</div>
        <div v-if="row.title" class="q-mb-md">
          <div class="text-weight-medium q-mb-xs">{{ $t('title') }}</div>
          <div class="text-body1">{{ row.title }}</div>
        </div>
        <q-list dense bordered class="rounded-borders q-mb-md">
          <q-item>
            <q-item-section>
              <q-item-label caption>{{ $t('activation_date_time') }}</q-item-label>
              <q-item-label>{{
                $moment(row.activation_date).locale($t('format_date')).format('L LT')
              }}</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-if="row.expiration_date">
            <q-item-section>
              <q-item-label caption>{{ $t('expiration_date_time') }}</q-item-label>
              <q-item-label>{{
                $moment(row.expiration_date).locale($t('format_date')).format('L LT')
              }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>

        <div class="text-weight-medium q-mb-sm">{{ $t('weekly_brief_free_text') }}</div>
        <q-input :value="row.description" type="textarea" autogrow readonly outlined class="q-mb-sm">
          <template v-slot:append>
            <q-btn
              round
              dense
              flat
              icon="content_copy"
              color="primary"
              @click="clickToCopy(row.description || '')"
            >
              <q-tooltip>{{ $t('weekly_brief_copy') }}</q-tooltip>
            </q-btn>
          </template>
        </q-input>

        <template v-if="row.audio_url">
          <div class="text-weight-medium q-mb-sm">{{ $t('weekly_brief_audio') }}</div>
          <audio
            ref="player"
            controls
            preload="metadata"
            playsinline
            :src="row.audio_url"
            class="full-width weekly-brief-audio"
          />
          <q-banner dense rounded class="q-mt-sm" :class="$q.dark.isActive ? 'bg-grey-9 text-grey-3' : 'bg-blue-1 text-dark'">
            <template v-slot:avatar>
              <q-icon name="mdi-download-circle-outline" :color="$q.dark.isActive ? 'grey-5' : 'primary'" size="md" />
            </template>
            <div class="text-body2">{{ $t('weekly_brief_audio_player_help') }}</div>
          </q-banner>
        </template>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'WeeklyBriefViewDialog',
  props: {
    value: { type: Boolean, default: false },
    row: { type: Object, default: null }
  }
};
</script>

<style scoped>
.weekly-brief-audio {
  min-height: 54px;
  vertical-align: middle;
}
</style>
